import React, { useEffect, useState } from 'react';
import './PrivacyPolicy.css';

const TermsOfService = () => {
    const [lastUpdated, setLastUpdated] = useState<string>('Loading...');

    useEffect(() => {
        const updateLastUpdated = () => {
            const element = document.querySelector('[ez-last-updated=""]');

            if (element?.textContent) {
                setLastUpdated(element.textContent.trim());
            }
        };

        const root = document.getElementById('__enzuzo-root');
        if (!root) return;

        root.innerHTML = '';

        document.getElementById('__enzuzo-root-script')?.remove();

        const script = document.createElement('script');
        script.id = '__enzuzo-root-script';
        script.src =
            'https://app.enzuzo.com/scripts/tos/7bc30294-5dd4-11f1-9d27-6faac70a8d03';
        script.async = true;

        script.onload = () => {
            setTimeout(updateLastUpdated, 1000);
        };

        root.appendChild(script);

        return () => {
            document.getElementById('__enzuzo-root-script')?.remove();
        };
    }, []);

    return (
        <div className="privacy-page">
            <div className="privacy-hero">
                <h1>Terms of Service</h1>
                {/* Uncomment if you want to show the date */}
                {/* <p>{lastUpdated}</p> */}
            </div>

            <div className="privacy-content">
                <div id="__enzuzo-root"></div>
            </div>
        </div>
    );
};

export default TermsOfService;